import React, { useState } from 'react';
import Slider from "react-slick";

import SectionTitle from '../../components/SectionTitle'
import SingleEvent from '../../components/Event/SingleEvent';
import bgImage from '../../assets/images/home/our-story.jpg'
import events from '../../data/Events.json';
import { Link } from 'react-router-dom';

const Event = ({storyList}) => {
    const eventSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    };
    // const stories = [
    //     { poster: "./img/story/poster-1.png" },
    //     { poster: "./img/story/poster-2.png" },
    //     { poster: "./img/story/poster-1.png" },

    //     { poster: "./img/story/poster-1.png" },
    //     { poster: "./img/story/poster-2.png" },
    //     { poster: "./img/story/poster-1.png" },

    //     { poster: "./img/story/poster-1.png" },
    //     { poster: "./img/story/poster-2.png" },
    //     { poster: "./img/story/poster-1.png" },
    // ];


    return (
        <div className="react-upcoming__event blog__area py-5" style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
            
            <div className="container">
                <SectionTitle Title="From Hope " subtitle="To Achievement" style/>
                <p className=' py-2 text-center' style={{ fontWeight: "600",color:"white" }}>
                Over the years, Ocfit has witnessed countless success stories. Our candidates have secured stable employment, started their own businesses, and positively contributed to their communities. Each success reinforces our belief in the potential of every individual.
                </p>

                <div className="event-slider owl-carousel wow animate__fadeInUp " data-wow-duration="0.3s">
                    <Slider {...eventSettings}>
                        {storyList?.map((item, index) => {
                            return (
                                <>
                                <div key={index} className='col p-2' style={{height:"250px"}}>
                                    <Link to={`/success-story-detail/${item?.slug}`}>
                                      <img className="shadow border-3 border-white p-2" width={380} height={300} src={item?.thumbnailImgUrl} style={{height:"100%",objectFit:"cover "}}/>
                                    </Link>
                                </div>
                                {/* // <div key={index} className="col-12 position-relative">
                                //     <video className="shadow border-3 border-white p-2 img-fluid" width={380} height={300} poster={item?.featureImgUrl}>
                                //         <source src={item?.thumbnailImgUrl} />
                                //     </video>
                                //     <button className="border-0 outline-none bg-transparent position-absolute top-50 start-50 translate-middle"><img src="./img/story/play.svg" width={60} height={60} /></button>
                                // </div> */}
                                </>

                            )
                        })
                        }
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default Event;